
import { defineComponent, ref, watchEffect, computed } from "vue";
import { FabricanteView } from "@/types/fabricantes/FabricanteView";

export default defineComponent({
  name: "selectFabricante",
  props: {
    modelValue: {
      type: Number,
      required: false
    },
    items: {
      type: Array,
      required: false
    },
    labelValue: {
      type: String,
      default: "Fabricante"
    },
    required: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const isSearching = ref(false);
    const filter = ref("");
    const myinput = ref(null);

    function showSearch() {
      filter.value = "";
      isSearching.value = !isSearching.value;
    }

    function search(filter: string): FabricanteView[] {
      const items = props.items as FabricanteView[];
      const filterOk = filter.toUpperCase();
      //if (filter.length < 2) return [];
      console.log(
        items.filter(
          item =>
            !item.inexistente &&
            (item.nombre.indexOf(filterOk) > -1 ||
              (item.codigo != null
                ? item.codigo.indexOf(filterOk) > -1
                : false))
        )
      );
      return items.filter(
        item =>
          !item.inexistente &&
          (item.nombre.indexOf(filterOk) > -1 ||
            (item.codigo != null ? item.codigo.indexOf(filterOk) > -1 : false))
      );
    }

    function selectItem(id: number) {
      isSearching.value = !isSearching.value;
      if (id != -1) {
        emit("update:modelValue", id);
      }
    }

    function clearValue() {
      emit("update:modelValue", null);
    }

    function valueShowed(): string {
      if (props.modelValue == 0) return "no hay fabricante seleccionado";
      if (props.modelValue == undefined) return "seleccione un fabricante";
      const items = props.items as FabricanteView[];
      const resultado = items.find(x => x.id == props.modelValue);
      if (resultado == undefined) return "Cargando ...";
      return resultado.nombre;
    }

    watchEffect(
      () => {
        if (myinput.value != null) {
          ((myinput.value as unknown) as HTMLInputElement).focus();
        }
      },
      {
        flush: "post"
      }
    );

    const showError = computed(() => {
      return (
        props.required &&
        props.showRequired &&
        (props.modelValue == null || props.modelValue == undefined)
      );
    });

    return {
      isSearching,
      filter,
      myinput,
      showSearch,
      search,
      valueShowed,
      selectItem,
      clearValue,
      showError
    };
  }
});
